<template>
    <div class="port-list" v-if="currentComponent">
        <el-card>
            <component
                :is="currentComponent"
                ref="portListComponent"
                :filters="filters"
            />
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'portList',
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            components: {
                PY: () =>
                    import(
                        '@/modules/warehouse/views/pages/main/components/port-list/py.vue'
                    )
            }
        };
    },
    mounted() {
    },
    computed: {
        currentComponent() {
            this.$emit('input', []);
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    },
    watch: {
    },
    methods: {
        getWarehouses() {
            this.$refs.warehouseListComponent.getWarehouses();
        }
    }
};
</script>

<style scoped lang="scss">
.port-list {
    margin-top: 16px;
}
</style>
